import React from "react"
import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"
import MarketoForm from "./MarketoForm"

const AssetForm = ({ content }) => {
  return (
    <Wrapper>
      <ContentDiv>
        <MarketoForm
          id={content.formId}
          ty={content?.thankYouPage}
          redirectLink={content?.redirectLink}
          animatedDemo={false}
        />
        <Body dangerouslySetInnerHTML={{ __html: content?.body }} />
      </ContentDiv>
    </Wrapper>
  )
}

export default AssetForm
const Body = styled.p`
  ${text.bodyMd};
  height: max-content;

  p {
    strong {
      ${text.bodyMdBold};
    }
    margin-bottom: 1.667vw;

    ${media.fullWidth} {
      margin-bottom: 24px;
    }

    ${media.tablet} {
      margin-bottom: 2.344vw;
    }

    ${media.mobile} {
      margin-bottom: 5.607vw;
    }
  }

  ul {
    ${text.bodyMd}
    list-style: none;
    margin-left: 0.347vw;
    margin-top: 2.804vw;
    margin-bottom: 2.804vw;

    ${media.fullWidth} {
      margin-left: 5px;
      margin-top: 40px;
      margin-bottom: 40px;
    }

    ${media.tablet} {
      margin-left: 0.488vw;
      margin-top: 3.906vw;
      margin-bottom: 3.906vw;
    }

    ${media.mobile} {
      margin-left: 1.168vw;
      margin-top: 9.346vw;
      margin-bottom: 9.346vw;
    }

    li {
      list-style: disc;
      list-style-position: inside;
      margin-bottom: 1.667vw;
      min-height: 2.5vw;

      ${media.fullWidth} {
        margin-bottom: 7px;
        min-height: 36px;
      }

      ${media.tablet} {
        margin-bottom: 0.684vw;
        min-height: 4.5vw;
      }

      ${media.mobile} {
        margin-bottom: 1.636vw;
        min-height: 8.5vw;
      }
    }
  }

  ol {
    position: relative;
    list-style: none;
    counter-reset: list-number;
    margin-left: 3.472vw;
    margin-top: 2.778vw;
    margin-bottom: 2.778vw;

    ${media.fullWidth} {
      margin-left: 50px;
      margin-top: 40px;
      margin-bottom: 40px;
    }

    ${media.tablet} {
      margin-left: 4.883vw;
      margin-top: 3.906vw;
      margin-bottom: 3.906vw;
    }

    ${media.mobile} {
      margin-left: 11.682vw;
      margin-top: 9.346vw;
      margin-bottom: 9.346vw;
    }

    li {
      min-height: 2.5vw;
      margin-bottom: 1.667vw;

      ${media.fullWidth} {
        min-height: 36px;
        margin-bottom: 24px;
      }

      ${media.tablet} {
        min-height: 3.516vw;
        margin-bottom: 2.344vw;
      }

      ${media.mobile} {
        min-height: 8.411vw;
        margin-bottom: 5.607vw;
      }
    }

    li::before {
      position: absolute;
      left: -4vw;
      content: counter(list-number);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      color: ${colors.primaryOrange};
      margin-right: 0.694vw;
      width: 2.5vw;
      height: 2.5vw;
      font-size: 1.25vw;
      border: 0.25vw solid ${colors.primaryOrange};

      ${media.fullWidth} {
        left: -58px;
        margin-right: 10px;
        width: 36px;
        height: 36px;
        font-size: 18px;
        border: 3px solid ${colors.primaryOrange};
      }

      ${media.tablet} {
        left: -5vw;
        margin-right: 0.977vw;
        width: 3.516vw;
        height: 3.516vw;
        font-size: 1.758vw;
        border: 0.293vw solid ${colors.primaryOrange};
      }

      ${media.mobile} {
        left: -11vw;
        margin-right: 2.336vw;
        width: 8.411vw;
        height: 8.411vw;
        font-size: 4.206vw;
        border: 0.701vw solid ${colors.primaryOrange};
      }
    }

    li {
      counter-increment: list-number;
    }
  }

  ${media.tablet} {
    margin-top: 5.859vw;
  }

  ${media.mobile} {
  }
`
const ContentDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row-reverse;
  width: 79.306vw;
  gap: 4.167vw;
  margin-top: -2.917vw;

  ${media.fullWidth} {
    width: 1142px;
    gap: 60px;
    margin-top: -42px;
  }

  ${media.tablet} {
    width: 91.992vw;
    gap: 5.859vw;
    margin-top: -4vw;
  }

  ${media.mobile} {
    width: 87.85vw;
    flex-direction: column-reverse;
    margin-top: 9.346vw;
    gap: 9.346vw;
  }
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`
